import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButton as MuiToggleButton, ToggleButtonGroup as MuiToggleButtonGroup, } from '@mui/material';
import { styled } from '../../utils';
export function ToggleButtonGroup(props) {
    const { options, value, onChange } = props;
    return (_jsx(MuiToggleButtonGroup, { color: "primary", value: value, exclusive: true, onChange: onChange, children: options?.map((option, i) => (_jsx(ToggleButtonStyled, { value: option.value, disabled: option.disabled, children: option.label }, typeof option.value === 'string' ? option.value : i))) }));
}
const ToggleButtonStyled = styled(MuiToggleButton)(({ theme }) => ({
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 10,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    '&:hover': {
        backgroundColor: theme.palette.info.main,
        border: `1px solid ${theme.palette.primary.main}`, // Has to be repeated here and under, specificity reasons
    },
    '&.Mui-selected': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.groupPrimary.dove,
        border: `1px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: theme.palette.groupPrimary.lightBlue,
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    '.Mui-disabled': {
        color: theme.palette.text.disabled,
        borderTopColor: theme.palette.text.disabled,
        borderBottomColor: theme.palette.text.disabled,
        '& + .Mui-disabled': {
            borderLeftColor: theme.palette.text.disabled,
        },
        '&:first-of-type': {
            borderLeftColor: theme.palette.text.disabled,
        },
        '&:last-of-type': {
            borderRightColor: theme.palette.text.disabled,
        },
    },
}));
